import { useEffect, useMemo } from 'react';

import { SourceInstitution } from 'types/source-institution';
import { usePersistentStore } from 'store/persistent';
import useSourceInstitutions from 'hooks/use-source-institutions';

export default function useSelectedSourceInstitution(): {
  selectedSourceInstitution: SourceInstitution | null;
  setSelectedSourceInstitution: (newSelectedSourceInstitution: string | null) => void;
  // eslint-disable-next-line indent
} {
  const selectedSourceInstitutionID = usePersistentStore((state) => state.selectedSourceInstitution);
  const setSelectedSourceInstitution = usePersistentStore((state) => state.setSelectedSourceInstitution);

  const sourceInstitutions = useSourceInstitutions();

  const selectedSourceInstitution = useMemo(
    () => (selectedSourceInstitutionID ? sourceInstitutions.get(selectedSourceInstitutionID) ?? null : null),
    [selectedSourceInstitutionID, sourceInstitutions],
  );

  // Clear out invalid source institution due to stale reference data
  useEffect(() => {
    if (sourceInstitutions.size === 0 || !selectedSourceInstitutionID) {
      return;
    }
    const validSourceInstitution = sourceInstitutions.has(selectedSourceInstitutionID);
    if (!validSourceInstitution) {
      setSelectedSourceInstitution(null);
    }
  }, [selectedSourceInstitution, setSelectedSourceInstitution, selectedSourceInstitutionID, sourceInstitutions]);

  return { selectedSourceInstitution, setSelectedSourceInstitution };
}
